import { getTimeTrackingAnalyticsFunctionDef } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import useSWR from 'swr';
export const timeTrackingAnalyticsKey = 'getTimeTrackingAnalytics';
export const useTimeTrackingAnalytics = () => {
    const getTimeTrackingAnalyticsPlatformFn = useTypedPlatformFunction(getTimeTrackingAnalyticsFunctionDef);
    const fetchTimeTrackingAnalytics = () => getTimeTrackingAnalyticsPlatformFn(null).catch(handleErrorSnackbar);
    const { data: timeTrackingAnalytics, mutate } = useSWR(timeTrackingAnalyticsKey, () => {
        return fetchTimeTrackingAnalytics()
            .then((response) => {
            return response;
        })
            .catch(handleErrorSnackbar);
    }, defaultFetcherOptions);
    return {
        timeTrackingAnalytics,
        fetchTimeTrackingAnalytics: mutate,
    };
};
